import styled from 'styled-components';

/* Coluna "Auditoria" das listas de faturas na identidade do app (out/2026,
 * pedido do Bruno): texto na fonte da tabela, sem a pílula de fundo bege/verde
 * e sem cores soltas — divergência em laranja com o ícone de alerta (link para
 * o relatório), "ok" em verde do tema. */
export const Pill = styled.a<{ $divergent: boolean }>`
  display: inline-flex;
  align-items: center;
  gap: 6px;
  font-family: ${(props) => props.theme.font.body.family};
  font-size: inherit;
  font-weight: 700;
  white-space: nowrap;
  text-decoration: none;
  font-variant-numeric: tabular-nums;
  color: ${(props) =>
    props.$divergent
      ? props.theme.color.ui.orange
      : props.theme.color.text.success};
  cursor: ${(props) => (props.$divergent ? 'pointer' : 'default')};

  svg {
    flex-shrink: 0;
  }

  &:hover {
    color: ${(props) =>
      props.$divergent
        ? props.theme.color.ui.orange
        : props.theme.color.text.success};
    text-decoration: ${(props) => (props.$divergent ? 'underline' : 'none')};
  }
`;
